import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';

import { SharedModule } from '../../../shared';
import { HomeMaterialModule } from '../../home-material/home-material.module';

import { AccountRewardsContentComponent } from './account-rewards-content/account-rewards-content.component';
import { CashPaymentAcknowledgmentComponent } from './cash-payment-acknowledgment/cash-payment-acknowledgment.component';
import { CashPaymentWorkflowComponent } from './cash-payment-workflow/cash-payment-workflow.component';
import { CashPaymentsLearnMoreComponent } from './cash-payments-learn-more/cash-payments-learn-more.component';
import { CashRewardsCarouselComponent } from './cash-rewards-carousel/cash-rewards-carousel.component';
import { RebateCoordinatorFormComponent } from './rebate-coordinator-form/rebate-coordinator-form.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SlickCarouselModule,
    SharedModule,
    HomeMaterialModule,
  ],
  declarations: [
    AccountRewardsContentComponent,
    CashPaymentAcknowledgmentComponent,
    CashPaymentWorkflowComponent,
    CashPaymentsLearnMoreComponent,
    CashRewardsCarouselComponent,
    RebateCoordinatorFormComponent,
  ],
  exports: [
    AccountRewardsContentComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class AccountRewardsModule {}
